import { render } from "./Chatroom.vue?vue&type=template&id=793089c2"
import script from "./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue?vue&type=script&lang=js"

import "./Chatroom.vue?vue&type=style&index=0&id=793089c2&lang=css"
script.render = render

export default script